module.exports = __webpack_public_path__ + "aa37b6f0526223ee0dd7f47f4c2ca16e.MP3";